import type React from 'react';
import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { useDispatchTrackEventWithLocation } from '../../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { ContactUsHistorycalData } from '../ContactUsHistorycalData';

import {
  StyledButton,
  StyledArrowIcon,
  StyledDropdown,
  StyledHistorycalDataIconContainer,
  StyledTextContainer,
} from './styles';

interface Props {
  numberOfMonths: number;
}

export const HistorycalDataIcon: React.FC<Props> = ({ numberOfMonths }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const { t } = useTranslation();

  const handleOpenDropdown = () => {
    setIsDropdownOpen(true);
    dispatchTrackEventWithLocation(
      'company data',
      'change historical data',
      `historical data options/${numberOfMonths}`
    );
  };

  const handleCloseDropdown = () => {
    setIsDropdownOpen(false);
  };

  return (
    <StyledHistorycalDataIconContainer>
      <StyledButton onClick={handleOpenDropdown} data-automation="Button" variant="flat">
        <SWReactIcons iconName="daily-ranking" size="xs" iconColor={colorsPalettes.carbon[400]} />
        <StyledTextContainer>
          {numberOfMonths} {t(numberOfMonths === 1 ? 'common.month' : 'common.months')}
        </StyledTextContainer>
        <StyledArrowIcon iconName="arrow" size="xs" isOpen={isDropdownOpen} iconColor={colorsPalettes.carbon[400]} />
      </StyledButton>
      <StyledDropdown isOpened={isDropdownOpen} onClose={handleCloseDropdown} minWidth="100%" placement="right">
        <ContactUsHistorycalData numberOfMonths={numberOfMonths} />
      </StyledDropdown>
    </StyledHistorycalDataIconContainer>
  );
};
